import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChineseCouterPipe, SafeResourcePipe } from './chineseCounter.pipe';
import { ChineseDataTimePipe } from './chineseDataTime.pipe';
import { TimeFormatPipe } from './timeFormat.pipe';
import { MediaTitlePipe, DecodeQueryPipe, CommaToArray, CommaToString } from './mediaTitle.pipe';
import { RelativeTimePipe } from './relativeTime.pipe';
import { CategoryPipe } from './category.pipe';
import { WrapPipe } from './wrap.pipe';
import { HtmlImagePipe, ReplaceHost, CustomImage, StaticImagePipe } from './staticHtml.pipe';
import { MinuteSecond } from './minute-second.pipe';
import { AbsUrlPipe } from './abs-url.pipe';
import { StaticLevelPipe } from './static-level.pipe';
// import { OneTimeDirective } from './ontTime.pipe';
import { DecimalPartOnlyPipe } from './decimalPartOnly.pipe';
import { IntegerPartOnlyPipe } from './integerPartOnly.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        ChineseCouterPipe,
        ChineseDataTimePipe,
        TimeFormatPipe,
        MediaTitlePipe,
        RelativeTimePipe,
        CategoryPipe,
        WrapPipe,
        HtmlImagePipe,
        DecodeQueryPipe,
        ReplaceHost,
        CustomImage,
        StaticImagePipe,
        SafeResourcePipe,
        MinuteSecond,
        AbsUrlPipe,
        StaticLevelPipe,
        DecimalPartOnlyPipe,
        IntegerPartOnlyPipe,
        CommaToArray,
        CommaToString
    ],
    exports: [
        ChineseCouterPipe,
        ChineseDataTimePipe,
        TimeFormatPipe,
        MediaTitlePipe,
        RelativeTimePipe,
        CategoryPipe,
        WrapPipe,
        HtmlImagePipe,
        DecodeQueryPipe,
        ReplaceHost,
        CustomImage,
        StaticImagePipe,
        SafeResourcePipe,
        MinuteSecond,
        AbsUrlPipe,
        StaticLevelPipe,
        DecimalPartOnlyPipe,
        IntegerPartOnlyPipe,
        CommaToArray,
        CommaToString
    ]
})
export class PipesModule { }
